export default __webpack_public_path__ + "static/media/why_us_bg.8278319f.png";